import * as React from 'react';

export function MockNotice() {
  return (
    <div className="mock-notice" role="note">
      <span className="mock-dot" aria-hidden="true" />
      MOCK MODE · демонстрационные данные, не производственная информация
    </div>
  );
}
